import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { type Quiz as QuizType} from './context/QuizContext';
import { useQuizContext } from './context/useQuizContext';
import { useNavigate } from 'react-router-dom';
import Question from './quiz/Question';
import Answers from './quiz/Answers';
import Navigation from './Navigation';

import './Quiz.css';
import Button from '../ui/Button';
import ComponentContainer from '../ui/ComponentContainer';

type Props = {
    quiz: QuizType,
    maxQuestions: number
}

export function Quiz({ quiz, maxQuestions }: Props) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const {
        questionIndex,
        setQuestionIndex,
        setAnswers,
        setPage,
        setPointsCounter,
    } = useQuizContext();

    function handleStart() {
        setQuestionIndex(0);
        setPointsCounter(0);
        setPage(0);
        setAnswers([]);
        navigate('/quizzes');
    }
    return (
        <ComponentContainer variant="quizSlide" spacing>
            <div className="quiz-slide-top">
                <Button
                    variant="back"
                    onClick={handleStart}>
                    <>
                        <FontAwesomeIcon icon={faArrowLeft} />{' '}
                        {t('general.back')}
                    </>
                </Button>
                <h4>{`${questionIndex + 1} / ${maxQuestions}`}</h4>
            </div>
            <Question quiz={quiz} />
            <Answers quiz={quiz} />
            <Navigation />
        </ComponentContainer>
    );
}